import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_DELETE_MASTER_INSTRUCTION } from "../../store/Instruction/instructionActionTypes";
import { useInstructionMaster } from "../../store/Instruction/reducer";
interface Props {
  instruction: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const InstructionDelete: React.FC<Props> = ({
  instruction,
  isOpen,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { masterInstruction: faqs, busy, message } = useInstructionMaster();
  const { _id } = instruction;
  const toast = useToast();

  useEffect(() => {
    const findFaq = faqs.find((val: Record<string, any>) => val._id === _id);
    if (!findFaq) {
      toast({
        title: "Success.",
        description: "Instruction Successfully deleted..",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [_id, faqs, onClose, toast]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Instruction</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_INSTRUCTION,
                payload: { _id: instruction._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default InstructionDelete;
